/* eslint-disable no-param-reassign */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import moment from "moment";
import { Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import { Tabs } from "../../../shared/widgets";
import { PageWrapper } from "../../../shared/layout";
import SettlementConfig from "./cityConfig/SettlementConfig";
import CityProfileConfig from "./cityConfig/CityProfileConfig";
import {
  fetchAllCityConfigsAction,
  upsertAdminConfigAction,

} from "../../../redux/action-creators/adminConfigActionCreator";

const getTabs = (configType) => {
  const tabs = [];
  if (configType === "agency-config") {
    tabs.push({ key: "agencyProfile", display: "Agency Profile" });
  } else {
    tabs.push({ key: "settlement", display: "Settlement" });
  }
  return tabs;
};

const extractUpdatedCycleDataConditonally = (cycle, updatedCycle) => {
  if (cycle.settlementCycle === "Monthly") {
    updatedCycle.cycleInfo.date = Number(
      cycle.settlementCutoffDate,
    );
    updatedCycle.dueScheduleInfo.date = Number(
      cycle.settlementRunDate,
    );
    updatedCycle.cycleInfo.billStartOffset = Number(
      cycle.offSetDate,
    );
  }
  if (cycle.settlementCycle === "Weekly") {
    updatedCycle.cycleInfo.day = cycle.settlementCutoffDay;
    updatedCycle.dueScheduleInfo.day = cycle.settlementRunDay;
    updatedCycle.cycleInfo.billStartOffset = Number(
      cycle.offSetDate,
    );
  }
};

const getCityProfileData = (agencyLevelAttributes) => ({
  contractType: agencyLevelAttributes?.contractType || "busLevel",
  rechargeAmountResponsibility:
    agencyLevelAttributes?.rechargeAmountResponsibility?.toLowerCase()
    || null,
  passIssued: agencyLevelAttributes?.passIssued || false,
  collectionHandledBy:
    agencyLevelAttributes?.collectionHandlingResponsibility?.toLowerCase()
    || "operator",
  passRevenueRecognition: agencyLevelAttributes?.passRevenueConfig === "afcsPassCities"
    ? "afcsData"
    : "salesData",
  passRevenueFlag: ["manual", "automatic"].includes(
    agencyLevelAttributes?.passRevenueConfig?.split("PassRevenueCities")[0],
  )
    ? agencyLevelAttributes?.passRevenueConfig?.split(
      "PassRevenueCities",
    )[0]
    : null,
});

const updateConfigData = (
  cityConfig,
) => {
  /*
    ** Update config data when config for particular city is fecthed.
  */
  const {
    agencyProfile: { agencyLevelAttributes = {} } = {},
    settlements: { settlementCycle = [], settlementCalculation = {} } = {},
  } = cityConfig;
  const cityProfileData = { ...getCityProfileData(agencyLevelAttributes) };

  const settlementData = { settlementCycleData: [] };

  for (const cycle of settlementCycle) {
    settlementData.includeMoneyLoaded = settlementCalculation
      ?.operatorSettlements?.moneyLoaded
      ? "yes"
      : "no";
    const settlementCycleInfo = {};
    settlementCycleInfo.settlementCycle = cycle?.cycleType?.charAt(0).toUpperCase()
        + cycle?.cycleType?.slice(1) || "Monthly";
    settlementCycleInfo.settlementCutoffTime = new Date(
      moment()?.set({
        hour: cycle?.cycleInfo?.time?.hour,
        minute: cycle?.cycleInfo?.time?.minutes,
        second: 0,
        millisecond: 0,
      }),
    );
    settlementCycleInfo.settlementRunTime = new Date(
      moment()?.set({
        hour: cycle?.dueScheduleInfo?.time?.hour,
        minute: cycle?.dueScheduleInfo?.time?.minutes,
        second: 0,
        millisecond: 0,
      }),
    );
    if (cycle.cycleType === "Weekly" || cycle.cycleType === "Monthly") {
      settlementCycleInfo.offSetDate = cycle?.cycleInfo?.billStartOffset;
      if (cycle.cycleType === "Weekly") {
        settlementCycleInfo.settlementCutoffDay = cycle?.cycleInfo?.day || "";
        settlementCycleInfo.settlementRunDay = cycle?.dueScheduleInfo?.day || "";
      } else {
        settlementCycleInfo.settlementCutoffDate = cycle?.cycleInfo?.date || "";
        settlementCycleInfo.settlementRunDate = cycle?.dueScheduleInfo?.date || "";
      }
    }
    settlementData.settlementStartDate = cycle?.operatorDueDay1;
    settlementData.settlementCycleData.push(settlementCycleInfo);
  }
  return { cityProfileData, settlementData };
};

const updateErrorStatus = (
  settlementConfigData,
  setErrorStatus,
  errorStatus,
) => {
  if (
    settlementConfigData.settlementCycle === "Monthly"
    && settlementConfigData.settlementCutoffDate
      > settlementConfigData.settlementRunDate
  ) {
    setErrorStatus({ ...errorStatus, runTimeError: true });
  } else {
    setErrorStatus({ ...errorStatus, runTimeError: false });
  }
};

function CityConfig(props) {
  const {
    location: {
      state: {
        configType,
        selectedCity: { cityName, cityId },
        selectedAgency: { name: agencyName, gpsId: agencyId },
      },
    },
  } = props;

  const tabs = [...getTabs(configType)];

  const dispatch = useDispatch();

  const cityConfig = useSelector((state) => state.AdminConfig.allCityConfigs);

  const [errorStatus, setErrorStatus] = useState({
    runTimeError: false,
  });
  const [cityProfileConfigData, setCityProfileConfigData] = useState({
    contractType: "busLevel",
    rechargeAmountResponsibility: "chalo",
    collectionHandledBy: "operator",
    passRevenueFromSales: "no",
    passRevenueFlag: "automatic",
    passRevenueRecognition: "",
    passIssued: false,
  });
  const [settlementConfigData, setSettlementConfigData] = useState({
    settlementStartDate: null,
    includeMoneyLoaded: "no",
    settlementCycleData: [
      {
        settlementCycle: "",
        settlementCutoffDate: null,
        settlementCutoffTime: new Date(),
        settlementRunDate: null,
        settlementRunTime: new Date(),
        settlementCutoffDay: "",
        settlementRunDay: "",
        offSetDate: "",
      },
    ],
  });
  const [cityProfileInitial, setCityProfileInitial] = useState();
  const [settlementInitial, setSettlementInitial] = useState();

  const handleCityProfileChange = ({ target: { name, value } }) => {
    setCityProfileConfigData({ ...cityProfileConfigData, [name]: value });
  };

  const handleSettlementChange = ({
    target: { name, value },
    cycleData,
    index,
  }) => {
    if (cycleData) {
      const settlementCycleData = [...settlementConfigData.settlementCycleData];
      settlementCycleData[index] = Object.keys(settlementCycleData[index]).length
        ? settlementCycleData[index] : {};
      settlementCycleData[index][name] = value;
      setSettlementConfigData({ ...settlementConfigData, settlementCycleData });
    } else {
      setSettlementConfigData({ ...settlementConfigData, [name]: value });
    }
  };

  const addSettlementHandler = () => {
    const newData = [
      ...settlementConfigData.settlementCycleData,
      {
        settlementCycle: "",
        settlementCutoffDate: "",
        settlementCutoffTime: new Date(),
        settlementRunDate: "",
        settlementRunTime: new Date(),
        settlementCutoffDay: "",
        settlementRunDay: "",
        offSetDate: "",
        isAdd: true,
      },
    ];

    setSettlementConfigData({
      ...settlementConfigData,
      settlementCycleData: newData,
    });
  };

  const handleRemoveSettlement = (index) => {
    settlementConfigData.settlementCycleData.splice(index, 1);
    setSettlementConfigData({
      ...settlementConfigData,
      settlementCycleData: settlementConfigData.settlementCycleData,
    });
  };

  const handleSubmit = (type) => {
    const data = {
      cityId,
      configType: type,
      configData: {},
    };
    if (type === "agencyProfile") {
      data.agencyId = agencyId;
      data.configData.agencyLevelAttributes = {
        contractType: cityProfileConfigData.contractType,
        // rechargeAmountResponsibility:
        //   cityProfileConfigData.rechargeAmountResponsibility,
        collectionHandlingResponsibility:
          cityProfileConfigData.collectionHandledBy,
        passIssued: cityProfileConfigData.passIssued === true,
      };

      // if (cityProfileConfigData.passRevenueRecognition === 'salesData') {
      //   data.configData.agencyLevelAttributes.passRevenueConfig =
      //  `${cityProfileConfigData.passRevenueFlag}PassRevenueCities`;
      // } else {
      //   data.configData.agencyLevelAttributes.passRevenueConfig = 'afcsPassCities';
      // }
    } else {
      const SettlementCycles = settlementConfigData.settlementCycleData.map((cycle) => {
        const updatedCycle = {
          cycleType: cycle.settlementCycle,
          cycleInfo: {
            time: {
              hour: moment(cycle.settlementCutoffTime).hour(),
              minutes: moment(
                cycle.settlementCutoffTime,
              ).minutes(),
            },
          },
          dueScheduleInfo: {
            time: {
              hour: moment(cycle.settlementRunTime).hour(),
              minutes: moment(cycle.settlementRunTime).minutes(),
            },
          },
          operatorDueDay1: moment(
            settlementConfigData.settlementStartDate,
          ).format("YYYY/MM/DD"),
        };

        extractUpdatedCycleDataConditonally(cycle, updatedCycle);

        return updatedCycle;
      });

      data.configData = {
        settlementCycle: SettlementCycles,
        settlementCalculation: {
          operatorSettlements: {
            ...(cityConfig?.settlements?.settlementCalculation
              ?.operatorSettlements || {}),
            moneyLoaded: settlementConfigData.includeMoneyLoaded === "yes",
          },
        },
      };
    }
    dispatch(upsertAdminConfigAction(data));
    setCityProfileInitial(cityProfileConfigData);
    setSettlementInitial(settlementConfigData);
  };

  useEffect(() => {
    /*
     ** Fetch city config.
     */
    dispatch(
      fetchAllCityConfigsAction(
        configType === "agency-config" ? { cityId, agencyId } : { cityId },
      ),
    );
  }, []);

  useEffect(() => {
    updateErrorStatus(
      settlementConfigData,
      setErrorStatus,
      errorStatus,
    );
  }, [
    settlementConfigData.settlementCutoffDate,
    settlementConfigData.settlementRunDate,
  ]);

  useEffect(() => {
    /*
     ** Update config data when config for particular city is fecthed.
     */
    const { cityProfileData, settlementData } = updateConfigData(cityConfig);

    setCityProfileConfigData(cityProfileData);
    setCityProfileInitial(cityProfileData);
    setSettlementConfigData(settlementData);
    // setSettlementInitial(settlementData);
  }, [cityConfig]);

  return (
    <PageWrapper className="pageContainer">
      <PageWrapper.Header
        heading={
          configType === "agency-config"
            ? `${cityName}, ${agencyName} Configuration`
            : `${cityName} Configuration`
        }
        hideS
        showBackArrow
        removeFilterOnly
      >
        <div className="dataTables_length tabWrapper scroll-tab">
          <Tabs
            activeTab={tabs[0].key}
            tabs={tabs}
            onTabSelection={() => {
              // eslint-disable-next-line no-console
              console.log();
            }}
          />
        </div>
      </PageWrapper.Header>
      <Box>
        <PageWrapper.Body style={{ backgroundColor: "white" }}>
          {tabs[0].key === "agencyProfile" ? (
            <CityProfileConfig
              configData={cityProfileConfigData}
              onChangeHandler={handleCityProfileChange}
              handleOnClick={handleSubmit}
              initial={cityProfileInitial}
            />
          ) : (
            <SettlementConfig
              configData={settlementConfigData}
              onChangeHandler={handleSettlementChange}
              handleOnClick={handleSubmit}
              errorStatus={errorStatus}
              initial={settlementInitial}
              addSettlementHandler={addSettlementHandler}
              onCloseCyclehandler={handleRemoveSettlement}
            />
          )}
        </PageWrapper.Body>
      </Box>
    </PageWrapper>
  );
}

export default CityConfig;
